import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { ListLayout } from '../../global/tables/table-list-layout';
import TableLoadingRow from '../../global/tables/table-loading-row';
import { Paging } from '../../global/_paging/paging-container';
import { PagingViewModel } from '../../global/_paging/paging-viewmodels/regular-paging.viewmodel';
import { IOperatorsDTO } from '../../../api/operators.dao';
import { connectOperatorVM } from '../operator.context';
import { OperatorsListItem } from './_operator-list-item/operator-list-item';

interface IProps {
    operatorsList: IOperatorsDTO[];
    pagingVM: PagingViewModel;
    intl?: IntlShape;
}

const OperatorsListPresentation = mobxReact.observer( ({ operatorsList, pagingVM, intl }) => {

    const title = <FormattedMessage
        id='oe.common.operators'
        defaultMessage='Operators'
        description='Label text'
    />;

    const thead = [
        intl.formatMessage({
            id: `oe.common.firstName`,
            defaultMessage: 'First Name',
            description: 'Label text',
        }),
        intl.formatMessage({
            id: `oe.common.lastName`,
            defaultMessage: 'Last Name',
            description: 'Label text',
        }),
        intl.formatMessage({
            id: `oe.common.email`,
            defaultMessage: 'Email',
            description: 'Label text',
        }),
    ];

    return (
        operatorsList &&
            <div className='page-container'>
                <section className='top-page-title horizontal-row horizontal-row--with-bottom-margin'>
                    <h1 className='text-ellipsis'>{title}</h1>
                </section>
                <section className='accounts-list fixed-list-layout'>
                    <ListLayout thead={thead}>
                        {operatorsList.length ? operatorsList.map((item: IOperatorsDTO) => {
                            return <OperatorsListItem {...item} key={item.operatorId} />;
                        }) : <TableLoadingRow colSpan={thead.length} contentLength={operatorsList.length} />}
                    </ListLayout>
                    <Paging pagingVM={pagingVM} />
                </section>
            </div>
    );
});

const FullOperatorsList = injectIntl(connectOperatorVM<IProps>(OperatorsListPresentation, vm => {
   return {
       operatorsList: vm.operatorsList,
       pagingVM: vm.paginationVM,
   };
}));

export { FullOperatorsList, OperatorsListPresentation };